module.exports = __webpack_public_path__ + "img/513.c74ed7ac.jpg";